module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-compare-reserve__claim-table"
  }, [_c('div', {
    staticClass: "p-compare-reserve__claim-table"
  }, [_c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.underLimit.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.underLimit.percent * 100, 2)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.withinLimit.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.withinLimit.percent * 100, 2)) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.overLimit.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.overLimit.percent * 100, 2)) + "%")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Total Claims")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Under Set Limit")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Within Set Limit")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Above Set Limit")])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("%")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("%")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', [_vm._v("%")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0b0cff6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/ResultsTable.vue
// module id = 1812
// module chunks = 0